import { IconNames } from '@ant-design/react-native/lib/icon';
import { DEVICE_ISSUE_TYPE, TDeviceIssueType, TDeviceIssueVerifyOutcome } from 'app/types/deviceIssue';

const STEPS_PER_ISSUE = 3;

const buildVerifyOutcomeConfig = (base: string, outcome: TDeviceIssueVerifyOutcome) => ({
  titleKey: `${base}.page.verify.${outcome}.title`,
  descriptionKey: `${base}.page.verify.${outcome}.description`,
});

const buildIssueConfig = (
  caseKey: keyof typeof DEVICE_ISSUE_TYPE,
  icon: IconNames,
  hasVerify: boolean,
  mediaConfig?: { remoteConfigKey: string },
) => {
  const base = `deviceIssues.${caseKey}`;

  return {
    icon,
    card: {
      titleKey: `${base}.card.title`,
      descriptionKey: `${base}.card.description`,
      ctaKey: `${base}.card.cta`,
    },
    page: {
      deviceIssue: DEVICE_ISSUE_TYPE[caseKey],
      titleKey: `${base}.page.title`,
      introKey: `${base}.page.intro`,
      problemKey: `${base}.page.problem`,
      stepKeys: Array.from({ length: STEPS_PER_ISSUE }, (_, index) => `${base}.page.steps.${index + 1}`),
      mediaConfig,
      verify: hasVerify
        ? {
          success: buildVerifyOutcomeConfig(base, 'success'),
          failure: buildVerifyOutcomeConfig(base, 'failure'),
        }
        : undefined,
    },
  };
};

export type TDeviceIssueConfig = ReturnType<typeof buildIssueConfig>;

export const DEVICE_ISSUE_VERIFY_OUTCOME_CONFIG: Record<
  TDeviceIssueVerifyOutcome,
  { icon: IconNames; circleClassName: string }
> = {
  success: { icon: 'check', circleClassName: 'bg-success-500' },
  failure: { icon: 'exclamation', circleClassName: 'bg-warning-500' },
};

export const DEVICE_ISSUE_CONFIG: Record<TDeviceIssueType, TDeviceIssueConfig> = {
  [DEVICE_ISSUE_TYPE.gatewayDisconnected]: buildIssueConfig('gatewayDisconnected', 'gateway', true, {
    remoteConfigKey: 'gateway_tutorial',
  }),
  [DEVICE_ISSUE_TYPE.tabletBatteryLow]: buildIssueConfig('tabletBatteryLow', 'thunderbolt', false, {
    remoteConfigKey: 'tablet_tutorial',
  }),
  [DEVICE_ISSUE_TYPE.routerWeakSignal]: buildIssueConfig('routerWeakSignal', 'wifi', true, {
    remoteConfigKey: 'router_tutorial',
  }),
};
